var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg04Cdr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 54 66",
    enableBackground: "new 0 0 54 66",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "51.5,63.9 2.7,63.9 2.7,2.1 36.7,2.1 51.5,17.7  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M52,64.4H2.1V1.6h34.8L52,17.5V64.4z M3.2,63.3h47.7V18L36.5,2.7H3.2V63.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C5C5C5",
    d: "M51.9,64.4H2V1.6h35.2l14.7,14.8V64.4z M3.1,63.3h47.7V16.9l-14-14.2H3.1V63.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBCBCB",
    d: "M39.1,22.6L36,26.6l-5.7-7.3c0,0-3.9,6.6-5.9,9.9c-1.1-0.4-2.2-0.7-3.4-0.7c-5,0-9,3.9-9.3,8.8l0,0h0 c0,0,0,0,0,0.1h18.7c0,0,0,0,0-0.1h12.1L39.1,22.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CBCBCB",
    cx: 18.7,
    cy: 17.9,
    r: 4.2
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#C5C5C5",
    points: "37,2.1 37,16.7 51.3,16.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 42.5,
    fill: "#50905E",
    width: 48.8,
    height: 21.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#50905E",
    d: "M51.9,64.4H2V42h49.9V64.4z M3.1,63.3h47.7V43.1H3.1V63.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M19.7,48.8c-1,0-1.8,0.3-2.4,1c-0.6,0.7-0.9,1.6-0.9,2.8c0,1.2,0.3,2.1,0.9,2.8c0.6,0.7,1.4,1,2.4,1 c0.6,0,1.4-0.1,2.2-0.3V57c-0.6,0.2-1.4,0.4-2.4,0.4c-1.4,0-2.4-0.4-3.2-1.2c-0.7-0.8-1.1-2-1.1-3.5c0-1,0.2-1.8,0.5-2.5 c0.4-0.7,0.9-1.3,1.5-1.7c0.7-0.4,1.5-0.6,2.4-0.6c1,0,1.8,0.2,2.5,0.5l-0.5,0.9C21.1,49,20.4,48.8,19.7,48.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M31.1,52.5c0,1.5-0.4,2.7-1.2,3.5c-0.8,0.8-2,1.2-3.6,1.2h-2.6V48h2.8c1.4,0,2.6,0.4,3.4,1.2 C30.7,50,31.1,51.1,31.1,52.5z M29.9,52.6c0-1.2-0.3-2.1-0.9-2.7c-0.6-0.6-1.5-0.9-2.7-0.9h-1.6v7.4h1.3c1.3,0,2.2-0.3,2.9-0.9 C29.6,54.8,29.9,53.8,29.9,52.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M34,53.4v3.8h-1.1V48h2.5c1.1,0,2,0.2,2.5,0.7c0.5,0.4,0.8,1.1,0.8,2c0,1.2-0.6,2-1.9,2.5l2.5,4.2h-1.3 l-2.2-3.8H34z M34,52.5h1.5c0.8,0,1.3-0.2,1.7-0.5c0.4-0.3,0.5-0.8,0.5-1.4c0-0.6-0.2-1.1-0.5-1.3c-0.4-0.3-0.9-0.4-1.7-0.4H34 V52.5z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg04Cdr);
export default __webpack_public_path__ + "static/media/04-cdr.c1a27ff36b89435a1097179635ad9ef8.svg";
export { ForwardRef as ReactComponent };